import React, { useState, useEffect, useRef } from "react";
import Header from "../components/Header";
import Breadcrumbs from "../components/Breadcrumbs";
import Footer from "../components/Footer";
import Seo from "../components/Seo";

const Blog = () => {
  const [showTop, setShowTop] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);
  const [iframeHeight, setIframeHeight] = useState(1500);
  const iframeRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    const onScroll = () => {
      setShowTop(window.pageYOffset > 400);
      const doc = document.documentElement;
      const max = doc.scrollHeight - doc.clientHeight;
      const p = max > 0 ? doc.scrollTop / max : 0;
      setScrollProgress(p);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Listen for height message from iframe (if legalplatform.co sends it)
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== "https://legalplatform.co") return;

      if (event.data?.type === "iframeHeight") {
        setIframeHeight(event.data.height);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  // Fallback: try to read height directly (works only if same domain)
  const handleIframeLoad = () => {
    try {
      const iframe = iframeRef.current;
      const height = iframe.contentWindow.document.body.scrollHeight;
      console.log(height);
      if (height > 0) setIframeHeight(height);
    } catch (e) {
      // Cross-origin — postMessage approach will handle it, or fallback height is used
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="info-page-wrapper font-inter">
      <Seo
        title="Blog — Legal Platform"
        description="Explore core services available on Legal Platform including contract review, drafting, legal consultation, and will preparation."
        canonicalPath="/blog"
        image="/favicon.png"
      />
      <Header />
      {/* <Breadcrumbs /> */}

      <iframe
        ref={iframeRef}
        src="https://legalplatform.co/blog/"
        onLoad={handleIframeLoad}
        frameBorder="0"
        width="100%"
        scrolling="no"
        title="Legal Platform Blog"
        style={{
          display: "block",
          height: `${iframeHeight}px`,
          overflow: "hidden",
          border: "none",
        }}
      />

      {showTop && (
        <button
          type="button"
          className="scroll-top-btn"
          onClick={scrollToTop}
          aria-label="Scroll to top"
          style={{ "--progress": `${Math.round(scrollProgress * 100)}%` }}
        >
          <span className="scroll-top-ring" />
          <i className="bi bi-arrow-up-short" />
        </button>
      )}
      <Footer />
    </div>
  );
};

export default Blog;